import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Clock, Shield } from 'lucide-react';

export default function Contatti() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Contatti</div>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Scrivici</h1>
      <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
        Il modo più veloce per raggiungerci è via email. Rispondiamo entro 48 ore lavorative, spesso molto prima.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <a href="mailto:info@agrinexus.it" className="rounded-2xl border border-border p-6 hover:border-chartreuse/60 transition-colors block group">
          <Mail className="text-chartreuse mb-4" size={24}/>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Informazioni generali</div>
          <div className="font-display text-xl mt-1 group-hover:text-chartreuse transition-colors">info@agrinexus.it</div>
          <p className="text-sm text-muted-foreground mt-2">Domande sul servizio, feedback, partnership, PR.</p>
        </a>
        <a href="mailto:info@agrinexus.it?subject=Richiesta%20GDPR" className="rounded-2xl border border-border p-6 hover:border-chartreuse/60 transition-colors block group">
          <Shield className="text-chartreuse mb-4" size={24}/>
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Privacy e GDPR</div>
          <div className="font-display text-xl mt-1 group-hover:text-chartreuse transition-colors">Richieste sui dati</div>
          <p className="text-sm text-muted-foreground mt-2">Accesso, rettifica, cancellazione, portabilità. Rispondiamo entro 30 giorni come previsto dal GDPR.</p>
        </a>
      </div>

      <div className="mt-12 rounded-2xl border border-border p-6 bg-secondary/30">
        <div className="flex items-start gap-4">
          <Clock className="text-muted-foreground shrink-0 mt-1" size={20}/>
          <div>
            <div className="font-medium">Tempi di risposta</div>
            <p className="text-sm text-muted-foreground mt-1">Lun–Ven 9:00–18:00 (fuso orario italiano). Le email inviate fuori orario o nei weekend vengono lette e gestite il primo giorno lavorativo utile.</p>
          </div>
        </div>
      </div>

      <div className="mt-8 rounded-2xl border border-chartreuse/40 bg-chartreuse/5 p-6">
        <div className="flex items-start gap-4">
          <MessageCircle className="text-chartreuse shrink-0 mt-1" size={20}/>
          <div>
            <div className="font-medium">Assistente AI</div>
            <p className="text-sm text-muted-foreground mt-1">Per domande su agricoltura, colture, normative italiane e valutazioni, prova prima <Link to="/assistente" className="underline text-foreground">l'assistente AI di AgriNexus</Link>: risponde in tempo reale 24/7 e spesso ti dà la soluzione più veloce di quanto potremmo noi via email.</p>
          </div>
        </div>
      </div>

      <div className="mt-12 text-sm text-muted-foreground flex flex-wrap gap-4">
        <Link className="link-underline" to="/chi-siamo">Chi siamo →</Link>
        <Link className="link-underline" to="/privacy">Privacy →</Link>
        <Link className="link-underline" to="/termini">Termini →</Link>
      </div>
    </div>
  );
}
